const NotFound=()=>{
    return <div>Pagina no encontrada</div>
}

export default NotFound;